import React from 'react';
import Link from '../atoms/link';
import lock from '../../images/lock.svg';
import logoWFS from '../../images/WFS-Logo_Dark.png';
import logoFDR from '../../images/freedom_logo.svg';

const Header = ({
	type='main',
	content
}) => {

	const secureLock = (type === 'main') ? <img src={lock} alt={content.rightColumnText} /> : null;

	const primaryLogo = (type !== 'fdr-only' ) ? (
		<div className='co-header__logo-primary'>
			{/* <Link url='/' image> */}
				<img src={logoWFS} alt='Logo' />
			{/* </Link> */}
		</div>
	) : null;

	return (
		<div className='co-header'>
			<div className='co-header__wrapper'>
				<div className='co-header__main-menu'>
					<div className='l-container'>
						<div className='l-grid__row'>
							<div className='l-grid__col-xs-7 l-grid__col-md-8 co-header__logo'>
								{primaryLogo}
								<div className="co-header__logo-secondary">
									{/* <Link url="/" image> */}
										<img src={logoFDR} alt="Logo" />
									{/* </Link> */}
								</div>
							</div>

							<div className='l-grid__col-xs-5 l-grid__col-md-4 co-header__secure'>
								{secureLock}
								<span>{content.rightColumnText}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
